export default (str) => str.replace(/\n/g, '');
